/**
 * RotaSla
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {PontaSla} from '@/model/resource/PontaSla'
import {Responsavel} from '@/model/resource/Responsavel'
import {RotaSlaCollection} from '@/model/collection/RotaSlaCollection'

/* TODO: review generated class */
export class RotaSla extends Resource {
  @ResponseSerialize(PontaSla)
  pontaSla1: PontaSla | null = null

  @ResponseSerialize(PontaSla)
  pontaSla2: PontaSla | null = null

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  idOrigemFk: number | null = null
  idDestinoFk: number | null = null
  valor: number | null = null

  get $id() {
    /* TODO: define the ID */
    return 0
  }
  set $id(val) {
    /* TODO: define the ID */
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  /**
   * Gets a instance of a given ID of RotaSla
   */
  async getRotaSla(id1: number, id2: number, id3: number) {
    return await Request.get(`/admin/rota-sla/${id1}/${id2}/${id3}`)
      .name('getRotaSla')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of RotaSla
   */
  static async listRotaSla(params: any) {
    return await Request.get(`/admin/rota-sla`, {params})
      .name('listRotaSla')
      .as(RotaSlaCollection)
      .getData()
  }

  /**
   * Persists a new instance of RotaSla. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistRotaSla() {
    return await Request.post(`/admin/rota-sla`, this)
      .name('persistRotaSla')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of RotaSla to use it in a CSV file
   */
  static async listCsvRotaSla(params: any) {
    return await Request.get(`/admin/rota-sla/csv`, {params})
      .name('listCsvRotaSla')
      .as(RotaSlaCollection)
      .getData()
  }
}
